module.exports = __webpack_public_path__ + "static/media/sacola.9e7ce907.svg";